import { render } from "./AreaEdit.vue?vue&type=template&id=ac944aa8&scoped=true"
import script from "./AreaEdit.vue?vue&type=script&lang=js"
export * from "./AreaEdit.vue?vue&type=script&lang=js"

import "./AreaEdit.vue?vue&type=style&index=0&id=ac944aa8&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac944aa8"]])

export default __exports__